import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Parallax } from 'react-scroll-parallax';
import { Player } from 'video-react';


import ImageContainer from '../ImageContainer';

import { getParallaxValue } from '../../helpers/getParallaxValue';

import './styles/values.scss';

class Values extends Component {

  constructor() {
    super();

    this.state = {
      startVideo: false,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ 
        startVideo : true 
      })
    }, 2000)
  }

  render() {

    const {
      screen,
    } = this.props;
    
    return (
      <div className="values">
        <div className="container-inner">
          <div className="section-title">
            <span>Do Deep Tech:</span>
            <h2>A&nbsp;statement of&nbsp;belief and values</h2>
          </div>
          <div className="values__intro">
            <div className="values__text">
              <div className="values__text__container">
                <p>It&rsquo;s time to&nbsp;do&nbsp;deep tech.</p>
                <p>Radical innovation is&nbsp;the key to&nbsp;our progress and survival. Every year, it&nbsp;becomes increasingly difficult to&nbsp;innovate: Moore&rsquo;s Law is&nbsp;effectively defunct due to&nbsp;fundamental natural limits. We&nbsp;are up&nbsp;against strict limitations in&nbsp;almost all areas of&nbsp;knowledge. The era of&nbsp;deep tech has arrived. It&rsquo;s time to&nbsp;put the human creative spirit first, be&nbsp;willing to&nbsp;take risks, and invest money and decades into scientific research&nbsp;&mdash; the consequences of&nbsp;which will be&nbsp;felt for generations to&nbsp;come.</p>
              </div>
            </div>
            <div className="values__block">
              <img src={require('../../static/images/gallery/image-6.jpg').default} alt="logo" />
            </div>
          </div>
          <div className="values__gallery gallery gallery--second">
            <div className="gallery__content">
              <div className="gallery-container">
                <Parallax y={getParallaxValue(screen, 2, 1)} className="_medium">
                  <ImageContainer src={require('../../static/images/gallery/image-7.jpg').default} />
                </Parallax>
                <Parallax y={getParallaxValue(screen, 2, 2)} className="_small">
                  {
                    this.state.startVideo
                    ? <Player
                        playsInline
                        autoPlay
                        loop
                        muted
                        preload="auto"
                        poster={require('../../static/images/gallery/image-8.jpg').default}
                        src={require('../../static/video/stay.mp4').default}
                      />
                    : <ImageContainer src={require('../../static/images/gallery/image-8.jpg').default} />
                  }
                </Parallax>
                <p>We&nbsp;have to&nbsp;declare science our new religion. We&nbsp;have to&nbsp;make its voice as&nbsp;loud as&nbsp;possible to&nbsp;help everyone recognize its value. We&nbsp;need to&nbsp;learn and remember the difference between facts and opinions, and always choose facts over bias.</p>
              </div>
              <div className="gallery-container">
                <p>Starting with individuals, moving on&nbsp;to&nbsp;companies, and then to&nbsp;governments, we&rsquo;ll prove that the deep tech approach can solve any issue of&nbsp;any size, for the benefit of&nbsp;all.</p>
              </div>
              <div className="gallery-container">
                <img src={require('../../static/images/gallery/image-9.jpg').default} alt="" />
                <p>Doing deep tech isn&rsquo;t about creating monetary value; it&rsquo;s about creating value for society. Money is&nbsp;not the driving force. We&nbsp;want deep tech to&nbsp;become the new social currency. We&nbsp;want a&nbsp;future where deep tech companies and governments reach an&nbsp;agreement to&nbsp;create a&nbsp;system of&nbsp;social currency that will replace the environmentally unsustainable aspects of&nbsp;capitalism.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="gallery__content">  
          <img src={require('../../static/images/gallery/image-10.jpg').default} alt="" className="_big" />
        </div>
        <div className="container-inner">
          <div className="values__gallery gallery gallery--third">
            <div className="gallery__content">
              <div className="gallery-container">
                <p>Anyone can do&nbsp;deep tech&nbsp;&mdash; that&nbsp;is, anyone who is&nbsp;armed with the proper knowledge and fearless. No&nbsp;one is&nbsp;there yet. You have to&nbsp;be&nbsp;a&nbsp;true trailblazer, going where others wouldn&rsquo;t dare. That&rsquo;s when you start to&nbsp;reshape everything&nbsp;&mdash; and we&rsquo;re here to&nbsp;help.</p>
              </div>
              <div className="gallery-container">
                <Parallax y={getParallaxValue(screen, 3, 1)} className="_medium">
                  <ImageContainer src={require('../../static/images/gallery/image-11.jpg').default} />
                </Parallax>
                <Parallax y={getParallaxValue(screen, 3, 2)} className="_small">
                  <ImageContainer src={require('../../static/images/gallery/image-12.jpg').default} />
                </Parallax>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    screen: state.screen.screen,
  }
}

export default connect(mapStateToProps, null)(Values);